import { PipesModule } from '@app/pipes/pipes.module';
import { PanierComponent } from './panier.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { StickyModule } from '@app/directives/sticky.module';
import { HelpycurrencyModule } from '@app/pipes/helpycurrency/helpycurrency.module';
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        PipesModule,
        StickyModule,
        HelpycurrencyModule
    ],
    declarations: [
        PanierComponent
    ],
    exports: [
        PanierComponent
    ]
})

export class PanierModule {}
